import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'reportTitle',
    label: 'Report Title',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
